import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd8065d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-section keys" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Key Return", -1))
const _hoisted_3 = { class: "btn-group mt-3" }
const _hoisted_4 = {
  key: 0,
  class: "form-group"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Name", -1))
const _hoisted_6 = {
  key: 1,
  class: "form-group"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Description", -1))
const _hoisted_8 = {
  key: 2,
  class: "form-group"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Description of events", -1))
const _hoisted_10 = {
  key: 3,
  class: "form-group"
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import Photos from "@/components/photo/Photos.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'KeysReturn',
  setup(__props) {

const store = useStore();

const report = computed(() => store.getters['reports/current']);
const setReportDeep = (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('reports/setReportDeep', payload);
};

const returntype = computed({
  get: () => report.value.keysreturn.returntype,
  set: (val: string) => store.dispatch('reports/setReportDeep', { path: 'keysreturn.returntype', data: val }),
});

const name = computed({
  get: () => report.value.keysreturn.name,
  set: (val: string) => store.dispatch('reports/setReportDeep', { path: 'keysreturn.name', data: val }),
});

const description = computed({
  get: () => report.value.keysreturn.description,
  set: (val: string) => store.dispatch('reports/setReportDeep', { path: 'keysreturn.description', data: val }),
});

const photos = computed({
  get: () => report.value.keysreturn.photos,
  set: (data) => setReportDeep({ path: 'keysreturn.photos', data })
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-light", { buttonselected: returntype.value === 'Tenant' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (returntype.value = 'Tenant'))
        }, "Tenant", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-light", { buttonselected: returntype.value === 'Agent' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (returntype.value = 'Agent'))
        }, "Agent", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-light", { buttonselected: returntype.value === 'Concierge' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (returntype.value = 'Concierge'))
        }, "Concierge", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-light", { buttonselected: returntype.value === 'Letterbox' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (returntype.value = 'Letterbox'))
        }, "Letterbox", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn btn-light", { buttonselected: returntype.value === 'Misc' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (returntype.value = 'Misc'))
        }, "Misc", 2)
      ]),
      (returntype.value === 'Agent' || returntype.value === 'Concierge')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((name).value = $event))
            }, null, 512), [
              [_vModelText, name.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (returntype.value === 'Agent' || returntype.value === 'Concierge')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((description).value = $event))
            }, null, 512), [
              [_vModelText, description.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (returntype.value === 'Misc')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((description).value = $event))
            }, null, 512), [
              [_vModelText, description.value]
            ])
          ]))
        : _createCommentVNode("", true),
      (returntype.value === 'Agent' || returntype.value === 'Concierge' || returntype.value === 'Letterbox' || returntype.value === 'Misc')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(), _createBlock(Photos, {
              photos: photos.value,
              path: 'keysreturn.photos',
              key: `${photos.value.length}`
            }, null, 8, ["photos", "path"]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})